/*
 * Mensa – PDP color gallery filter.
 * Shows only the photos of the currently selected color in the main media slider,
 * the thumbnail strip, the slider dots and the media modal.
 * Media <li> items carry data-mcg="|color-handle|" (rendered by
 * snippets/product-media-gallery.liquid via snippets/mensa-color-gallery-map.liquid).
 * Products without a color option (no data-mcg-idx on <media-gallery>) are untouched.
 */
(function () {
  if (window.MensaColorGallery) return;
  var HIDDEN = 'mcg-hidden';

  function parseMap(gallery) {
    if (gallery._mcgMap) return gallery._mcgMap;
    try {
      gallery._mcgMap = JSON.parse(gallery.dataset.mcgMap || '{}');
    } catch (e) {
      gallery._mcgMap = {};
    }
    return gallery._mcgMap;
  }

  function scopeOf(gallery) {
    return gallery.closest('product-info') || gallery.closest('.shopify-section') || document;
  }

  function colorValueFromDom(gallery, idx) {
    var scope = scopeOf(gallery);
    var script = scope.querySelector('variant-selects [data-selected-variant]');
    if (script) {
      try {
        var v = JSON.parse(script.textContent);
        if (v && v.options && v.options[idx] != null) return v.options[idx];
      } catch (e) {}
    }
    var selects = scope.querySelector('variant-selects');
    if (!selects) return null;
    var inputs = selects.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown');
    var box = inputs[idx];
    if (!box) return null;
    var checked = box.querySelector('input:checked');
    if (checked) return checked.value;
    var sel = box.querySelector('select');
    return sel ? sel.value : null;
  }

  function selectedHandle(gallery, variant) {
    var idx = parseInt(gallery.dataset.mcgIdx, 10);
    if (isNaN(idx)) return null;
    var value = null;
    if (variant && variant.options && variant.options[idx] != null) value = variant.options[idx];
    if (value == null) value = colorValueFromDom(gallery, idx);
    if (value == null) return null;
    var map = parseMap(gallery);
    return map[value] || null;
  }

  function apply(gallery, reason, variant) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    var handle = selectedHandle(gallery, variant);
    if (!handle && reason !== 'init') return; // unknown selection: leave as is
    var key = handle ? '|' + handle + '|' : null;

    var slides = Array.prototype.slice.call(viewer.querySelectorAll('li[data-mcg]'));
    var any = !!key && slides.some(function (li) { return (li.dataset.mcg || '').indexOf(key) > -1; });
    var match = function (el) { return !any || (el.dataset.mcg || '').indexOf(key) > -1; };

    var visible = 0;
    var visibleIds = {};
    slides.forEach(function (li) {
      var m = match(li);
      li.classList.toggle(HIDDEN, !m);
      if (m) {
        visible++;
        visibleIds[String(li.dataset.mediaId || '').split('-').pop()] = true;
      }
    });

    // slider dots: only as many as visible slides
    viewer.querySelectorAll('.slider-counter__link').forEach(function (dot) {
      dot.classList.toggle(HIDDEN, parseInt(dot.dataset.index, 10) > visible);
    });

    if (thumbs) {
      thumbs.querySelectorAll('li[data-mcg]').forEach(function (li) {
        li.classList.toggle(HIDDEN, !match(li));
      });
      thumbs.classList.toggle(HIDDEN, visible < 2);
      thumbs.classList.toggle('thumbnail-slider--no-slide', visible <= 3);
      thumbs.querySelectorAll(':scope > .slider-button').forEach(function (btn) {
        btn.classList.toggle('small-hide', visible <= 3);
        btn.classList.toggle('medium-hide', visible <= 4);
        btn.classList.toggle('large-up-hide', visible <= 4);
      });
    }

    // media modal / lightbox: only walk the visible color's media
    var sectionId = (gallery.id || '').replace(/^MediaGallery-/, '').replace(/-duplicate$/, '');
    var modal = document.getElementById('ProductModal-' + sectionId);
    if (modal) {
      modal.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(function (el) {
        el.classList.toggle(HIDDEN, any && !visibleIds[String(el.dataset.mediaId)]);
      });
    }

    if (viewer.resetPages) viewer.resetPages();
    if (thumbs && thumbs.resetPages) thumbs.resetPages();

    var changed = gallery._mcgLast !== handle;
    gallery._mcgLast = handle;
    if (!changed || reason === 'init') return;

    // color switched: go to the variant image (or first visible slide) of the new color
    setTimeout(function () {
      var active = viewer.querySelector('li.is-active[data-mcg]:not(.' + HIDDEN + ')') ||
        viewer.querySelector('li[data-mcg]:not(.' + HIDDEN + ')');
      if (!active) return;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(active.dataset.mediaId, false);
      } else if (viewer.slider) {
        viewer.slider.scrollTo({ left: active.offsetLeft });
      }
      if (viewer.resetPages) viewer.resetPages();
      if (thumbs && thumbs.resetPages) thumbs.resetPages();
    }, 60);
  }

  function galleries() {
    return document.querySelectorAll('media-gallery[data-mcg-idx]');
  }

  function watch(gallery) {
    if (gallery._mcgWatched) return;
    gallery._mcgWatched = true;
    var list = gallery.querySelector('[id^="GalleryViewer"] ul');
    if (!list || !window.MutationObserver) return;
    var t;
    // fallback for variant changes that re-order/prepend gallery items without publishing variantChange
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { apply(gallery, 'mutation'); }, 30);
    }).observe(list, { childList: true });
  }

  function init() {
    galleries().forEach(function (g) {
      apply(g, 'init');
      watch(g);
    });
  }

  window.MensaColorGallery = { apply: apply, init: init };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      galleries().forEach(function (g) {
        watch(g);
        var info = g.closest('product-info');
        var own = info && data.sectionId && (info.dataset.originalSection || info.dataset.section) === data.sectionId;
        apply(g, 'change', own ? data.variant : null);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
